import React, { useState, useEffect } from "react";
import styles from "./css/PreviewPage.module.css";
import { useNavigate } from "react-router-dom";
import PauseIcon from "@mui/icons-material/Pause";
import LinearProgress from "@mui/material/LinearProgress/LinearProgress";
import PlayCircleIcon from "@mui/icons-material/PlayCircle";
import backArrow from "../../assets/arrowBackwards.png";
import forwardArrow from "../../assets/arrowForwards.png";
import { ToastContainer, toast } from "react-toastify";
import DoneIcon from "@mui/icons-material/Done";
import floricele from "../../assets/floricele.png";
import RemoveIcon from "@mui/icons-material/Remove";
import AddIcon from "@mui/icons-material/Add";
import imageBook from "../../assets/dummy_book.jpg";
import axios from "axios";
import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";
import { useSelector } from "react-redux";
import { FormControl, Select, MenuItem } from "@mui/material";
import { useSearchParams } from "react-router-dom";

const PreviewPage: React.FC = () => {
  const navigate = useNavigate();

  const [searchParams] = useSearchParams();
  const propFormat = searchParams.get("format");

  const [isExpanded, setIsExpanded] = useState(false);

  const language = useSelector((state: any) => state.language.value);

  const [isPlaying, setIsPlaying] = useState(false);
  const audioRef = React.useRef<HTMLAudioElement>(null);
  const [audioUrl, setAudioUrl] = useState<string | null>(null);

  const [bookFormat, setBookFormat] = useState(propFormat || "");
  const [bookLanguage, setBookLanguage] = useState("");

  const handleBookFormat = (event: SelectChangeEvent) => {
    setBookFormat(event.target.value);
  };

  const handleBookLanguage = (event: SelectChangeEvent) => {
    setBookLanguage(event.target.value);
  };

  useEffect(() => {
    console.log("prop format:");
    console.log(propFormat);
  }, [propFormat]);

  const images = [
    {
      original: imageBook,
      thumbnail: imageBook,
    },
    {
      original: imageBook,
      thumbnail: imageBook,
    },
    {
      original: imageBook,
      thumbnail: imageBook,
    },
  ];

  const handleViewCart = () => {
    navigate("/cart");
  };

  const handlePlay = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_SERVER_URL}/audio`,
        {
          responseType: "blob",
        }
      );

      if (response.status !== 200) {
        throw new Error("File not found or failed to fetch");
      }

      const blob = response.data; // Get the file as a Blob
      const url = URL.createObjectURL(blob); // Create a URL for the audio file
      setAudioUrl(url); // Set the URL in the state

      if (audioRef.current) {
        if (isPlaying) {
          audioRef.current.pause();
          audioRef.current.currentTime = 0; // Reset the audio playback position
        } else {
          audioRef.current.play();
        }
      }

      setIsPlaying(!isPlaying); // Toggle the isPlaying state
    } catch (error) {
      console.error("Error while fetching the audio file:", error);
    }
  };

  const handleAudioEnd = () => {
    setIsPlaying(false);
    setProgress(0); // Reset progress when audio ends
  };

  const handleAudioTimeUpdate = () => {
    if (audioRef.current) {
      const currentTime = audioRef.current.currentTime;
      const duration = audioRef.current.duration;

      if (duration > 0) {
        const newProgress = (currentTime / duration) * 100;
        setProgress(newProgress); // Update progress based on currentTime and duration
      }
    }
  };

  useEffect(() => {
    if (audioRef.current) {
      audioRef.current.addEventListener("timeupdate", handleAudioTimeUpdate);
      audioRef.current.addEventListener("ended", handleAudioEnd); // Handle audio end event
    }

    return () => {
      if (audioRef.current) {
        audioRef.current.removeEventListener(
          "timeupdate",
          handleAudioTimeUpdate
        );
        audioRef.current.removeEventListener("ended", handleAudioEnd);
      }
    };
  }, [isPlaying]);

  const handleCheckout = () => {
    navigate("/checkout");
  };

  const [quantity, setQuantity] = useState<number>(1);

  const increaseQuantity = () => setQuantity((prev) => prev + 1);
  const decreaseQuantity = () => setQuantity((prev) => Math.max(1, prev - 1));

  // Load quantity from localStorage on component mount
  useEffect(() => {
    const savedQuantity = localStorage.getItem("quantity");
    if (savedQuantity) {
      setQuantity(Number(savedQuantity));
    }
  }, []);

  const notify = (message?: string) => {
    if (message) {
      toast(message, {
        position: "top-right",
        autoClose: 2500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: "light",
      });
      return;
    }

    toast(
      <div
        style={{
          display: "flex",
          alignItems: "center",
          flexDirection: "column",
          width: "100%",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            width: "100%",
            marginBottom: "5%",
          }}
        >
          <DoneIcon />
          {language === "EN" && "Item added to your cart!"}
          {language === "RO" && "Produs adăugat în coș!"}
        </div>
        <div style={{ display: "flex" }}>
          <img
            src={imageBook}
            alt="Product"
            style={{
              width: "70px",
              height: "70px",
              marginRight: "10px",
              borderRadius: "5px",
            }}
          />
          <div>
            <strong>Spirit liber audiobook</strong>
            <p style={{ margin: "5px 0", fontSize: "14px" }}>
              {language === "EN" && "Product added to cart!"}
              {language === "RO" && "Produs adăugat în coș!"}
            </p>
          </div>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "5px",
            marginTop: "10px",
          }}
        >
          <button
            className={styles.button12}
            style={{
              border: "1px solid #517059",
              background: "unset",
            }}
          >
            <span
              className={styles.addToCart}
              style={{ color: "#517059" }}
              onClick={handleViewCart}
            >
              {language === "EN" && "View cart"}
              {language === "RO" && "Vezi coșul"}
            </span>
          </button>
          <button className={styles.button12} onClick={handleCheckout}>
            <span className={styles.addToCart}>
              {language === "EN" && "Checkout"}
              {language === "RO" && "Finalizare comandă"}
            </span>
          </button>
          <span onClick={() => navigate("/")}>
            <b style={{ textDecoration: "underline" }}>
              {language === "EN" && "Continue shopping"}
              {language === "RO" && "Continuă cumpărăturile"}
            </b>
          </span>
        </div>
      </div>,
      {
        position: "top-right",
        autoClose: 2500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: "light",
      }
    );
  };

  useEffect(() => {
    localStorage.setItem("quantity", String(quantity));
  }, [quantity]);

  const [progress, setProgress] = useState(0);
  const [buffer, setBuffer] = useState(0);

  // Handle adding to cart with quantity adjustment if item already exists
  const addToCart = () => {
    if (!bookFormat || !bookLanguage) {
      language === "EN" &&
        notify(
          "Please select both book format and language before adding to cart!"
        );

      language === "RO" &&
        notify(
          "Vă rugăm să selectați atât formatul cărții, cât și limba înainte de a adăuga în coș!"
        );

      return;
    }

    notify();

    const cartItem = {
      name: "Spirit liber audiobook",
      price: 62,
      quantity: quantity,
      image: imageBook,
      format: bookFormat,
      language: bookLanguage,
    };

    const existingCart = JSON.parse(localStorage.getItem("cartItems") || "[]");

    // Remove any item with the same name but different format
    const updatedCart = existingCart.filter(
      (item: any) =>
        !(item.name === cartItem.name && item.format !== cartItem.format)
    );

    // Check if the same item with the same format and language already exists
    const existingItemIndex = updatedCart.findIndex(
      (item: any) =>
        item.name === cartItem.name &&
        item.format === cartItem.format &&
        item.language === cartItem.language
    );

    if (existingItemIndex >= 0) {
      // If it exists, update the quantity by summing the old quantity and the new quantity
      updatedCart[existingItemIndex].quantity += cartItem.quantity;
    } else {
      // If it doesn't exist, add the new item to the cart
      updatedCart.push(cartItem);
    }

    // Save the updated cart to localStorage
    localStorage.setItem("cartItems", JSON.stringify(updatedCart));
  };

  return (
    <div className={styles.mainContainer}>
      <div className={styles.frame}>
        <div className={styles.frame1}>
          <div className={styles.header}>
            <span className={styles.spiritLiberAudiobook}>
              {language === "EN"
                ? "'FREE SPIRIT' audiobook"
                : `„SPIRIT LIBER" în format audio.`}
            </span>
            <span className={styles.spiritLiberAudiobook2}>
              {language === "EN"
                ? "'FREE SPIRIT' audiobook"
                : `„SPIRIT LIBER" în format audio.`}
            </span>
          </div>
          <div className={styles.rectangle}>
            <img src={floricele} style={{ width: "inherit" }} />
          </div>
        </div>
        <div className={styles.frame3}>
          <div className={styles.frame4}>
            <div className={styles.rectangle5} />
            <div className={styles.frame6}>
              <span className={styles.diaryTool}>
                Дневник "Узнай себя лучше" — это инструмент для тех, кто хочет
                глубже понять свои мысли,
              </span>
              <div className={styles.frame7}>
                {isPlaying ? (
                  <PauseIcon
                    className={styles.playButton}
                    onClick={handlePlay}
                    style={{ fill: "#517159", height: "48px", width: "48px" }}
                  />
                ) : (
                  <PlayCircleIcon
                    className={styles.playButton}
                    onClick={handlePlay}
                    style={{ fill: "#517159", height: "48px", width: "48px" }}
                  />
                )}

                {audioUrl && (
                  <audio
                    style={{ visibility: "hidden", width: "0" }}
                    key={audioUrl} // Add a key prop
                    ref={audioRef}
                    controls
                    autoPlay={isPlaying} // Set autoPlay to false
                    onEnded={handleAudioEnd}
                  >
                    <source src={audioUrl} type="audio/mpeg" />
                  </audio>
                )}
                <div className={styles.frame8}>
                  <img src={backArrow} className={styles.image} />
                  <button className={styles.frameA}>
                    <span className={styles.x}>1x</span>
                  </button>
                  <img src={forwardArrow} className={styles.image2} />
                </div>
              </div>
            </div>
          </div>

          <div className={styles.frameC}>
            {/* <span className={styles.span}>00:00</span> */}
            <div className={styles.frameD}>
              <LinearProgress
                sx={{
                  "& .MuiLinearProgress-bar1Buffer": {
                    backgroundColor: "#C4B57C",
                  },
                  "& .MuiLinearProgress-bar2Buffer": {
                    backgroundColor: "#C4B57C4D",
                  },
                  "& .MuiLinearProgress-dashed": {
                    display: "none",
                  },
                }}
                style={{ width: "100%", height: "100%" }}
                variant="buffer"
                value={progress}
                valueBuffer={buffer}
              />
            </div>
            <span className={styles.spanF}>30:00</span>
          </div>
        </div>
        <div className={styles.frame10}>
          <span className={styles.productDescription}>
            {language == "RO" && "Despre carte"}
            {language == "EN" && "About the book"}
          </span>
          <span className={styles.diaryTool11}>
            {language == "RO" &&
              'Cartea "SPIRIT LIBER" surprinde povestea unei femei care a descoperit că adevărata libertate nu se află în locurile exterioare, ci în profunzimea ființei sale. Scrisă din diferite colțuri ale lumii — Italia, Londra, Hong Kong și Bali — cartea urmărește călătoria unei femei care a ales să trăiască autentic, eliberată de convenții sociale și așteptări impuse.'}
            {language == "EN" &&
              'FREE SPIRIT" tells the story of a woman who discovered that true freedom does not lie in external places, but deep within her own being. Written from various corners of the world — Italy, London, Hong Kong, and Bali — the book follows the journey of a woman who chose to live authentically, free from societal conventions and imposed expectations.'}
          </span>
          {isExpanded && (
            <>
              <span className={styles.diaryTool11}>
                {language == "RO" &&
                  'În acest roman autobiografic sunt surprinse trei istorii de iubire care redau în profunzime momentele și provocările vieții de cuplu. Autoarea explorează cu sinceritate debordantă cum doi oameni, uniți inițial de iubire, pot transforma relația într-o colivie pentru un spirit liber. Prin aceste povești, ea oferă lecții valoroase despre iubire, pierderi, lecții învățate și curajul de a te elibera. Succesul în carieră a fost și el o parte importantă a călătoriei sale. Deși recunoașterea profesională a validat abilitățile și munca depusă, ea a înțeles că adevăratul succes vine din armonia interioară și din trăirea în acord cu propriile valori. Pe parcurs, întâlnirile cu oameni inspirați i-au oferit lecții esențiale. Fiecare persoană i-a fost un ghid, oferindu-i curaj, încredere și înțelegerea că autenticitatea este cheia unei vieți împlinite. A învățat să renunțe la frici și blocaje interioare, să se desprindă de relațiile care nu îi hrăneau spiritul și să își redescopere puterea interioară. Aceste revelații au devenit catalizatorul transformării ei personale.  „SPIRIT LIBER" nu este doar o poveste de viață, ci și un ghid inspirațional către libertate. Această carte te învață să te dezbraci de limite și să-ți extinzi larg aripile, spunând cu încredere: "Viață, uimește-mă!" Pentru că viața este o poveste în continuă schimbare, iar tu ești aici să o trăiești din plin, fără frică. "Sunt fericită. Sunt împlinită. Dacă mâine va trebui să o iau de la zero, o voi lua din nou. Fiecare început este o oportunitate, fiecare sfârșit un nou început. Nu știu ce mi-a pregătit universul mai departe, dar știu un lucru: voi lua de la viață tot ce poate lua un spirit liber. " Această carte este despre curajul de a-ți urma visurile, despre eliberare și despre regăsirea păcii interioare într-o lume agitată. Este un drum spre adevăr, iubire de sine și autenticitate – un drum care poate fi și al tău.'}
                {language == "EN" &&
                  'In this autobiographical novel, three love stories are recounted, each delving into the moments and challenges of life as a couple. The author explores with unflinching honesty how two people, initially united by love, can transform their relationship into a cage for a free spirit. Through these stories, she offers valuable lessons on love, loss, learned experiences, and the courage to break free. Career success also plays a pivotal role in her journey. Although professional recognition validated her skills and hard work, she came to realize that true success arises from inner harmony and living in alignment with one`s values. Along the way, encounters with inspired people provided essential lessons. Each person served as a guide, offering her courage, trust, and the understanding that authenticity is the key to a fulfilling life. She learned to let go of fears and inner blocks, to detach from relationships that no longer nourished her spirit, and to rediscover her inner strength. These revelations became the catalyst for her personal transformation. "FREE SPIRIT" is not just a life story, but an inspirational guide to freedom. This book teaches you how to shed your limits and stretch your wings wide, confidently saying: "Life, surprise me!" Because life is an ever-changing story, and you are here to live it fully, without fear. "I am happy. I am fulfilled. If I had to start over tomorrow, I would do it again. Every beginning is an opportunity, every ending a new beginning. I don`t know what the universe has in store for me next, but one thing I do know: I will take everything life has to offer a free spirit." This book is about the courage to follow your dreams, about liberation, and about finding inner peace in a chaotic world. It is a journey to truth, self-love, and authenticity — a journey that could also be yours.'}
              </span>
            </>
          )}
          <span
            style={{
              color: "#c4b57c",
              cursor: "pointer",
              fontWeight: "bold",
            }}
            onClick={() => setIsExpanded(!isExpanded)}
          >
            {isExpanded
              ? language === "EN"
                ? "Show less"
                : "Arată mai puțin"
              : language === "EN"
              ? "Read more..."
              : "Citește mai mult..."}
          </span>
          {/* <span className={styles.practicalExercises}>
            В нем вы найдете практичные задания, медитативные упражнения и
            вопросы, которые побудят вас взглянуть на свою жизнь с нового
            ракурса. Погружение в себя с помощью этого дневника поможет повысить
            уровень удовлетворенности от жизни и улучшить ваше эмоциональное
            состояние.
          </span> */}
        </div>
        <div className={`${styles.mainContent} mainContent`}>
          <div className={styles.mainContainerImage}>
            <div className={styles.book}>
              <ImageGallery showPlayButton={false} items={images} />
            </div>
          </div>
          <div className={styles.productContainer}>
            <div className={styles.productInfo}>
              <span className={styles.productTitle}>
                Spirit liber audiobook
              </span>
              <div className={styles.priceContainer}>
                <span className={styles.discountedPrice}>62 RON / 12 €</span>
                {/* <span className={styles.originalPrice}>70 leo RON</span> */}
                {/* <span className={styles.discountedPrice}>62 leo RON</span>
                <button className={styles.sale}>
                  <span className={styles.saleTag}>Sale</span>
                </button> */}
              </div>
              <div className={styles.taxInfo}>
                <span className={styles.taxIncluded}>
                  {" "}
                  {language === "RO"
                    ? "Preț valabil exclusiv online! TVA-ul este inclus  "
                    : "Price valid exclusively online! VAT included  "}
                </span>
                <span className={styles.shipping}>
                  {language === "RO" ? "Cost Livrare: " : "Shipping Cost: "}
                </span>
                <span className={styles.calculatedAtCheckout}>
                  {language === "RO"
                    ? "va fi calculat în pagina de comandă."
                    : "will be calculated at checkout."}
                  {language == "RO" && "va fi calculat în pagina de comandă."}
                </span>
              </div>
            </div>
            <div className={styles.divider} />
            <div className={styles.formControl}>
              <FormControl
                sx={{ width: "100%", border: "none", borderRadius: "0" }}
              >
                <Select
                  sx={{
                    border: "none",
                    borderRadius: "0",
                    color: "#517059",
                    fontFamily: "inherit",
                  }}
                  value={bookLanguage}
                  onChange={handleBookLanguage}
                  displayEmpty
                  renderValue={(selected) => {
                    if (!selected) {
                      return (
                        <em
                          style={{
                            fontStyle: "inherit",
                            fontFamily: "inherit",
                            color: "#517059",
                          }}
                        >
                          {language === "EN" ? "Language" : "Limba"}
                        </em>
                      );
                    }
                    return selected === "en" ? "English" : "Romana";
                  }}
                >
                  <MenuItem
                    value={"ro"}
                    sx={{ color: "#517059", fontFamily: "inherit" }}
                  >
                    Romana
                  </MenuItem>
                  <MenuItem
                    value={"en"}
                    sx={{ color: "#517059", fontFamily: "inherit" }}
                  >
                    English
                  </MenuItem>
                </Select>
              </FormControl>
            </div>
            <div className={styles.formControl}>
              <FormControl
                sx={{ width: "100%", border: "none", borderRadius: "0" }}
              >
                <Select
                  sx={{
                    border: "none",
                    borderRadius: "0",
                    color: "#517059",
                    fontFamily: "inherit",
                  }}
                  value={bookFormat}
                  onChange={handleBookFormat}
                  displayEmpty
                  renderValue={(selected) => {
                    if (!selected) {
                      return (
                        <em
                          style={{
                            fontStyle: "inherit",
                            fontFamily: "inherit",
                            color: "#517059",
                          }}
                        >
                          {language === "EN" ? "Order format" : "Format"}
                        </em>
                      );
                    }
                    if (selected === "pdf") return "PDF, EPUB, MOBI";
                    if (selected === "audio") return "Audio";
                    return language === "RO"
                      ? "Format fizic"
                      : "Physical format";
                  }}
                >
                  <MenuItem
                    value={"pdf"}
                    sx={{ color: "#517059", fontFamily: "inherit" }}
                  >
                    PDF, EPUB, MOBI
                  </MenuItem>
                  <MenuItem
                    value={"audio"}
                    sx={{ color: "#517059", fontFamily: "inherit" }}
                  >
                    Audio
                  </MenuItem>
                  <MenuItem
                    value={"physical"}
                    sx={{ color: "#517059", fontFamily: "inherit" }}
                  >
                    {language === "RO" && "Format fizic"}
                    {language === "EN" && "Physical format"}
                  </MenuItem>
                </Select>
              </FormControl>
            </div>
            <div className={styles.quantityContainer}>
              <div className={styles.button}>
                <RemoveIcon
                  className={styles.decreaseQuantity}
                  onClick={decreaseQuantity}
                />
                <span className={styles.quantity}>{quantity}</span>
                <AddIcon
                  className={styles.increaseQuantity}
                  onClick={increaseQuantity}
                />
              </div>
              <button className={styles.button12} onClick={addToCart}>
                <span className={styles.addToCart}>
                  {" "}
                  {language == "RO" && "Adaugă în coș"}
                  {language == "EN" && "Add to cart"}
                </span>
              </button>
              <ToastContainer
              // position="bottom-right"
              // autoClose={2500}
              // hideProgressBar={false}
              // newestOnTop={false}
              // closeOnClick={false}
              // rtl={false}
              // pauseOnFocusLoss
              // draggable
              // pauseOnHover
              // theme="light"
              />
            </div>
            <div className={styles.divider13} />
            <div className={styles.productDetails}>
              {language === "RO" ? (
                <>
                  <span>
                    <strong>Detalii produs:</strong>
                  </span>
                  <span>
                    <strong>Format:</strong> A5. Ideal pentru a fi purtat în
                    geantă.
                  </span>
                  <span>
                    <strong>Audio:</strong> Accesul la fișierul audio va fi
                    oferit prin contul tău personal pe site-ul nostru.
                  </span>
                  <span>
                    <strong>Dimensiuni:</strong>
                  </span>
                  <span>
                    <strong>Coperta:</strong> tare
                  </span>
                  <span>
                    <strong>Limba:</strong> română
                  </span>
                  <span>
                    <strong>Numărul de pagini:</strong> 200
                  </span>
                </>
              ) : (
                <>
                  <span>
                    <strong>Product details:</strong>
                  </span>
                  <span>
                    <strong>Format:</strong> A5. Ideal for carrying in your bag.
                  </span>
                  <span>
                    <strong>Audio:</strong> Access to the audio file will be
                    provided through your personal account on our website.
                  </span>
                  <span>
                    <strong>Dimensions:</strong>
                  </span>
                  <span>
                    <strong>Cover:</strong> Hardback
                  </span>
                  <span>
                    <strong>Language:</strong> Romanian
                  </span>
                  <span>
                    <strong>Number of pages:</strong> 200
                  </span>
                </>
              )}
            </div>
            <div
              className={styles.copyrightNotice}
              style={{ fontSize: "0.8rem" }}
            >
              {language === "EN" ? (
                <>
                  <span>
                    <strong>*Copyright Notice</strong>
                  </span>
                  <br />
                  <br />
                  <span>
                    All materials and products available on this website,
                    including texts, images, designs, and other forms of
                    content, are protected by the{" "}
                    <strong>
                      Copyright and Related Rights Law no. 8/1996.
                    </strong>
                  </span>
                  <br />
                  <br />
                  <span>
                    Copying, reproducing, distributing, or using any of these
                    materials without written consent from the rights holder is
                    strictly prohibited and constitutes a violation of
                    applicable laws.
                  </span>
                  <br />
                  <br />
                  <span>
                    Thank you for respecting creative work and intellectual
                    property rights.
                  </span>
                </>
              ) : (
                <>
                  <span>
                    <strong>
                      *Notă informativă privind drepturile de autor
                    </strong>
                  </span>
                  <br />
                  <br />
                  <span>
                    Toate materialele și produsele disponibile pe acest site,
                    inclusiv texte, imagini, designuri și alte forme de
                    conținut, sunt protejate conform Legii nr. 8/1996 privind
                    dreptul de autor și drepturile conexe.
                  </span>
                  <br />
                  <br />
                  <span>
                    Copierea, reproducerea, distribuirea sau utilizarea
                    neautorizată a acestora, în orice formă, fără acordul scris
                    al titularului drepturilor, este strict interzisă și
                    constituie o încălcare a legislației în vigoare.
                  </span>
                  <br />
                  <br />
                  <span>
                    Vă mulțumim pentru respectarea muncii creative și a
                    drepturilor de proprietate intelectuală.
                  </span>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PreviewPage;
